<template>
  <div class="noticeDetail">
    <div class="container">
      <div class="notice_title">
        <h3>{{ detail.title }}</h3>
        <p>发布时间：{{ detail.publishTime }}</p>
      </div>
      <div class="notice_content" v-html="detail.content">
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noticeDetail',
  data () {
    return {
      detail: {}
    }
  },
  mounted () {
    let { id } = this.$route.query
    this.getactivityDetail(id)
  },
  methods: {
    async getactivityDetail(id) {
      let { data: { data, code  }} = await this.$http.get('api/information/selectDetailById/' + id)
      console.log(data);
      if(code != 0) return
      this.detail = data
    }
  }
}
</script>

<style lang="scss">
.noticeDetail {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0 auto;
  }
  .notice_title {
    padding: 30px 0 10px;
    text-align: center;
    border-bottom: 1px solid #f4f4f5;
    h3 {
      font-size: 24px;
      font-weight: 500;
      line-height: 1.5;
    }
    p {
      font-size: 14px;
      line-height: 26px;
    }
  }
  .notice_content {
    padding: 20px 0;
  }
}
</style>